import { ASSET_PREFIX } from 'utils/constants';

const TokenRedemptionCostPill = ({
  redemptionCost,
}: {
  redemptionCost: number;
}) => (
  <div className="tokenRedemptionCostPill flexRow">
    <img src={`${ASSET_PREFIX}/images/token-town/arcade-token.svg`} />

    <p style={{ whiteSpace: 'nowrap' }}>
      {redemptionCost === 0 ? (
        <span style={{ fontSize: '0.9em' }}>FREE</span>
      ) : (
        <>
          <strong>{redemptionCost}</strong> token
          {redemptionCost === 1 ? '' : 's'}
        </>
      )}
    </p>

    <style jsx>
      {`
        .tokenRedemptionCostPill {
          background-color: white;
          border-radius: 50px;
          font-weight: 700;
          padding: 10px;
          position: relative;
          font-size: 0.9em;
          z-index: 2;
        }

        img {
          height: 13px;
          margin-right: 0.6em;
        }

        @media (min-width: 360px) {
          .tokenRedemptionCostPill {
            font-size: inherit;
          }

          img {
            height: 15px;
          }
        }

        .tokenRedemptionCostPill p {
          margin: 0;
        }
      `}
    </style>
  </div>
);

export default TokenRedemptionCostPill;
